import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/guide-tips/face-shape/_components/FaceShapeClient.tsx");
